// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ulpGP","newExpiryDate":"styles_newExpiryDate__3NZoV","footer":"styles_footer__1D-Re"};